/**
 * A function for negating predicates
 * @param predicate
 */
export const not = <T>(predicate: (value: T) => boolean) => (value: T): boolean =>
  !predicate(value);
